import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import ForgotPasswordFormComponent from "../../components/forgotPasswordForm/forgotPasswordForm";

export default function ForgotPasswordPage() {
    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Forgot Password | Prepal</title>
                <meta name="description" content="Reset your Prepal account password. Enter your email to receive a password reset link." />
                <meta name="keywords" content="Prepal, forgot password, reset password, account recovery" />
                <meta name="author" content="Prepal Team" />
            </Helmet>
            <ForgotPasswordFormComponent />
        </>
    );
}